export default function CartIcon({ color = "white" }: { color?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91016 20.5885C5.91016 19.7485 6.59016 19.0685 7.43016 19.0685C8.26016 19.0685 8.94016 19.7485 8.94016 20.5885C8.94016 21.4185 8.26016 22.0985 7.43016 22.0985C6.59016 22.0985 5.91016 21.4185 5.91016 20.5885ZM17.1602 20.5885C17.1602 19.7485 17.8402 19.0685 18.6802 19.0685C19.5102 19.0685 20.1902 19.7485 20.1902 20.5885C20.1902 21.4185 19.5102 22.0985 18.6802 22.0985C17.8402 22.0985 17.1602 21.4185 17.1602 20.5885Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1907 6.34903C20.8007 6.34903 21.2007 6.55903 21.6007 7.01903C22.0007 7.47903 22.0707 8.13903 21.9807 8.73803L21.0307 15.298C20.8507 16.559 19.7707 17.488 18.5007 17.488H7.59074C6.26074 17.488 5.16074 16.468 5.05074 15.149L4.13074 4.24803L2.62074 3.98803C2.22074 3.91803 1.94074 3.52803 2.01074 3.12803C2.08074 2.71803 2.47074 2.44803 2.88074 2.50803L5.26574 2.86803C5.60574 2.92903 5.85574 3.20803 5.88574 3.54803L6.07574 5.78803C6.10574 6.10903 6.36574 6.34903 6.68574 6.34903H20.1907ZM14.1307 11.548H16.9007C17.3207 11.548 17.6507 11.208 17.6507 10.798C17.6507 10.378 17.3207 10.048 16.9007 10.048H14.1307C13.7107 10.048 13.3807 10.378 13.3807 10.798C13.3807 11.208 13.7107 11.548 14.1307 11.548Z"
        fill={color}
      />
    </svg>
  );
}
